const riot = require('riot');

riot.tag2('page-record', '<div class="f s-full"> <div class="box-shadow" if="{!app.useragent.isMobile}" ref="sidebar" data-is="module-sidebar"></div> <div class="f fclm s-full p32 overflow-y-scroll s-p12"> <div class="f fm flex-fixed mb32 s-mb12"> <div class="w-full mr16" if="{!app.useragent.isMobile}" ref="recorder" data-is="module-recorder" projects="{projects}" templates="{templates}" recent-history-records="{recentHistoryRecords}"></div> <div class="flex-fixed mr8" data-is="module-user-select" ref="users" users="{users}" current-user="{currentUser}"></div> <div class="flex-fixed" data-is="module-project-select" ref="projects" projects="{projects}"></div> </div> <div class="f fclm w-full flex-auto bg-white rounded-4 box-shadow py32 px24 overflow-hidden s-p12"> <div class="f s-full overflow-hidden"> <div class="f fclm fbw flex-fixed w182 h-full pr24 border-right border-separator_opaque mr24" if="{!app.useragent.isMobile}"> <div class="h-full" data-is="module-template" ref="template" templates="{templates}"></div> </div> <div class="relative s-full"> <div class="s-full" ref="calendar" data-is="module-calendar" users="{users}" projects="{projects}"></div> <div class="absolute trbl0 z100 f fh s-full bg-white" if="{isLoading}"> <div class="s40" data-is="atom-indicator"></div> </div> </div> </div> </div> <div class="flex-fixed" if="{app.useragent.isMobile}" data-is="module-tabbar"></div> </div> </div> <div class="popup fixed z100 bg-black s32" ref="popup"></div>', 'page-record,[data-is="page-record"]{display:block}', '', function(opts) {
    this.isLoading = false;

    this.on('mount', () => {
      if (!spat.isNode && !app.useragent.isMobile) {

        this.refs.recorder.on('recordingstart', (record) => {

          this.refs.calendar.activeRecord = record;
          this.refs.calendar.recordToEvent(record);
        });
        this.refs.recorder.on('recordingstop', (record) => {

          var event = this.refs.calendar.calendar.getEventById(record.id);
          if (event) {
            event.remove();
            this.refs.calendar.activeRecord = null;
            this.refs.calendar.recordToEvent(record);
          }
        });
        this.refs.recorder.on('recordremove', (record) => {
          var event = this.refs.calendar.calendar.getEventById(record.id);
          if (event) {
            this.refs.calendar.activeRecord = null;
            event.remove();
          }
        });

        this.refs.calendar.on('setupactiverecord', () => {
          this.refs.recorder.setup(this.refs.calendar.activeRecord);
        });

        this.refs.template.on('submit', async () => {
          var templates = await app.store.collection('users').doc(app.store.currentUser.id).collection('templates').fetch({ relation: true });
          this.templates = this.sortTemplates(templates);
          this.update();
        });
      }

      this.refs.calendar.on('changeview', () => {
        this.filterCalendar();
      });
      this.refs.calendar.on('refresh', async () => {
        this.recentHistoryRecords = await this.fetchRecentHistoryRecords();
        this.update();
      });

      this.refs.projects.on('select', (project) => {
        this.currentProject = project;
        this.filterCalendar();
      });

      this.refs.users.on('select', (user) => {
        this.currentUser = user;
        history.replaceState(null, null, `${location.origin}/record?user_id=${user.id}`);
        this.filterCalendar();
      });

    });

    this.on('startrecorder', (item) => {
      this.refs.recorder.startRecorderFromRecord(item);
    });

    this.preload = async ({req, res}) => {
      this.isLoading = true;
      this.update();
      if (spat.isNode) return;

      var promises = [
        app.store.collection('users')
          .where('disabled', '==', false)
          .fetch({ relation: true }),
        app.store.collection('projects')
          .where('archived', '==', false)
          .fetch({ relation: true }),
        app.store.collection('users').doc(app.auth.currentUser.uid).collection('templates').fetch({ relation: true }),
        this.fetchRecentHistoryRecords(),
      ];

      var [users, projects, templates, recentHistoryRecords] = await Promise.all(promises);

      users = app.utils.sortUserName(users);
      projects.sort((a, b) => a.data.name.toLowerCase() < b.data.name.toLowerCase() ? -1 : 1);
      templates = this.sortTemplates(templates);

      var all_project = { id: 'all', data: { name: 'all' }, all: true };
      projects.unshift(all_project);

      var unselected_project = { id: 'unselect', data: { name: '未設定' }, unselected: true };
      projects.push(unselected_project);

      return {
        users: users,
        projects: projects,
        templates,
        recentHistoryRecords,
      };
    };

    this.setUpSelectedUser = (user_id) => {
      let user = this.users.find(user => user.id === user_id);
      this.currentUser = user || app.store.currentUser;
      this.update();
      this.refs.users.setup();
    };

    this.on('show', async ({req, res}) => {
      this.intervalId = setInterval(() => {
        this.update();
      }, 1000);

      this.selectMe();
      if (this.refs.calendar.calendar) {
        this.filterCalendar();
      }

      const selected_user_id = req.query.user_id || "";
      this.setUpSelectedUser(selected_user_id);

      await app.utils.wait(128);

      this.refs.calendar.setup();

      if (!app.useragent.isMobile && !this.draggable) {
        var draggable = new FullCalendar.Draggable(this.refs.template.refs.body, {
          itemSelector: '.fc-event',
          eventData: (eventEl) => {
            var template = this.templates.find(t => t.id === eventEl.dataset.templateId);
            var color = template.getColor();
            var classNames = ['rounded-8'];
            return {
              title: template.data.title,
              duration: template.data.duration || app.data.template.defaultDuration,

              backgroundColor: color + '0D',
              borderColor: color,
              textColor: '#2E2E38',
              classNames: classNames,
              extendedProps: {
                template: template,
              },
            };
          },
        });
        this.draggable = draggable;
      }
      this.isLoading = false;
      this.update();
    });

    this.on('hide', () => {
      clearInterval(this.intervalId);
    });

    this.selectMe = () => {
      this.currentUser = app.store.currentUser;
      this.update();
    };

    this.filterCalendar = () => {
      var select_user = this.currentUser;
      var project = this.currentProject;

      if (project && !project.unselected && !project.all) {
        var select_project = this.projects.find(p => p.id === project.id);
      }

      else if (project && project.unselected) {
        select_project = '未設定';
      }
      else {
        var select_project = null;
      }

      this.refs.calendar.fetchEvents(select_user, select_project);
    };

    this.sortTemplates = (items) => {
      var templates = items.sort((a, b) => {
        var a_name = a.relation.project && a.relation.project.doc.exists ? a.relation.project.data.name.toLowerCase() : '';
        var b_name = b.relation.project && b.relation.project.doc.exists ? b.relation.project.data.name.toLowerCase() : '';
        if (a_name === b_name) {
          return 0;
        }
        return a_name < b_name ? -1 : 1;
      });

      return templates;
    };

    this.fetchRecentHistoryRecords = () => {

      if (!app.store.currentUser) return;

      var recentHistoryRecords = app.store.collection('records')
        .where('created_user_ref', '==', app.store.currentUser.ref)
        .orderBy('created_at', 'desc')
        .limit(3)
        .fetch({ relation: true });

      return recentHistoryRecords;
    };
});